import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuOptions } from '../../components/menu/SideBar';
import { produce } from 'immer';
import { ScenesReplayListKey } from '../../components/menu/Scenes/replayScenes/scenesReplayData';
import { TScenesReplay } from '../../components/menu/Scenes/replayScenes/ScenesReplay';
import Game from '../../shell/Game';



export interface TSettings {
    page?: number | string,
    fullscreen?: boolean,
    windowed?: boolean,
    skipUnseenText?: boolean,
    textOverlay?: boolean,
    musicVolume: number,
    initialized: boolean,
    skipSpeedValue: number,
    folder: string,

}
export type GameEndings = 'alpha' | 'normal';
export interface TMenuINT {
    menuState: MenuOptions,
    display: boolean,
    settings: TSettings,
    loading: boolean,
    sceneReplayScrollPos: number,
    showStarterScreen: boolean,
    showEnding: GameEndings | null,
    mobileImage: string,
    hovered: MenuOptions;
    gallery: { [key: string]: TScenesReplay; };
}

const menuSlice = createSlice({
    name: 'menu',
    initialState: {
        menuState: MenuOptions.INIT,
        display: true,
        settings: {
            page: 0,
            windowed: true,
            skipUnseenText: false,
            musicVolume: 30,
            folder: 'default',
            initialized: false,
            skipSpeedValue: 15,
        },
        gallery: {},
        sceneReplayScrollPos: 0,
        loading: false,
        showEnding: null,
        showStarterScreen: true
    } as TMenuINT,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setMenu: (state, { payload }: PayloadAction<Partial<TMenuINT>>) => {
            return { ...state, ...payload };
        },
        setSettings: (state, { payload }: PayloadAction<Partial<TSettings>>) => {
            return produce(state, draft => {
                draft.settings = { ...draft.settings, ...payload };

            });
        },
        setHover: (state, { payload }: PayloadAction<MenuOptions>) => {
            return produce(state, draft => {
                draft.hovered = payload;

            });
        },
        setGallery: (state, { payload }: PayloadAction<TScenesReplay & { ID: ScenesReplayListKey; }>) => {
            return produce(state, draft => {
                // draft.gallery = { [payload.ID]: { ...draft.gallery, ...payload } };
                draft.gallery = { ...draft.gallery, [payload.ID]: payload };

            });
        },
        setInitialized: (state, { payload }: PayloadAction<boolean>) => {
            return produce(state, draft => {
                // draft.gallery = { [payload.ID]: { ...draft.gallery, ...payload } };
                draft.settings.initialized = payload;

            });
        },
    },

});

export const {
    setMenu,
    setSettings,
    setInitialized,
    setHover,
    setGallery,
} = menuSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectMenu = (state: RootState) => state.menu;
export const selectSettings = (state: RootState) => state.menu.settings;
export const selectHovered = (state: RootState) => state.menu.hovered;
export const selectGallery = (state: RootState) => state.menu.gallery;



export default menuSlice.reducer;
